import { useEffectOnce } from 'react-use';
import { useRouter } from 'next/router';
import { logger } from '@zep/core-logger';
import { cn } from '@zep/utils';
import { LandingChart } from '../../components/service/home/LandingChart';
import { LandingCTA } from '../../components/service/home/LandingCTA';
import { LandingHero } from '../../components/service/home/LandingHero';
import { LandingNumbers } from '../../components/service/home/LandingNumbers';
import { LandingProduct, ProductSectionsWrapper } from '../../components/service/home/LandingProduct';
import { LandingRecruitBanner } from '../../components/service/home/LandingRecruitBanner';
import { LandingShortcut } from '../../components/service/home/LandingShortcut';
import { productSectionsData } from '../../consts/landingConsts';
export const LandingPageView = () => {
  const {
    locale
  } = useRouter();
  useEffectOnce(() => {
    logger.track('enter_landing');
  });
  return <main className={cn('overflow-hidden', locale === 'ko' ? 'word-break-keep-all' : '')} data-sentry-component="LandingPageView" data-sentry-source-file="landing.tsx">
      <LandingHero data-sentry-element="LandingHero" data-sentry-source-file="landing.tsx" />
      <LandingShortcut data-sentry-element="LandingShortcut" data-sentry-source-file="landing.tsx" />
      <LandingNumbers data-sentry-element="LandingNumbers" data-sentry-source-file="landing.tsx" />
      <ProductSectionsWrapper data-sentry-element="ProductSectionsWrapper" data-sentry-source-file="landing.tsx">
        {productSectionsData.map(data => <LandingProduct key={data.id} data={data} />)}
      </ProductSectionsWrapper>
      <LandingChart data-sentry-element="LandingChart" data-sentry-source-file="landing.tsx" />
      <LandingCTA data-sentry-element="LandingCTA" data-sentry-source-file="landing.tsx" />
      <LandingRecruitBanner data-sentry-element="LandingRecruitBanner" data-sentry-source-file="landing.tsx" />
    </main>;
};